import { useState } from 'react';
import { ISpinButtonProps } from '@fluentui/react';

import { MergeField } from '../type';
import { isAddDaysValid } from '../helpers/nonSFDCMergeFields';

interface UseNonSFDCTodayPlusNMergeFieldOutput {
  selectedNonSFDCMergeField: MergeField | null;
  daysToAdd: number;
  handleAddDays: (
    event: React.SyntheticEvent<HTMLElement>,
    newValue?: string,
  ) => void;
  handleResetDaysToAdd: () => void;
  setNonSFDCMergeField: (value: MergeField | null) => void;
}

export const useNonSFDCTodayPlusNMergeField =
  (): UseNonSFDCTodayPlusNMergeFieldOutput => {
    const [selectedNonSFDCMergeField, setSelectedNonSFDCMergeField] =
      useState<MergeField | null>(null);
    const [daysToAdd, setDaysToAdd] = useState<number>(1);

    const handleAddDays: ISpinButtonProps['onChange'] = (
      _e,
      numberOfDays,
    ): void => {
      if (isAddDaysValid(selectedNonSFDCMergeField, numberOfDays)) {
        setDaysToAdd(Number(numberOfDays));
      }
    };

    const handleResetDaysToAdd = (): void => {
      setDaysToAdd(1);
    };

    return {
      selectedNonSFDCMergeField,
      daysToAdd,
      handleAddDays,
      handleResetDaysToAdd,
      setNonSFDCMergeField: setSelectedNonSFDCMergeField,
    };
  };

export default useNonSFDCTodayPlusNMergeField;
